import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@mui/material/Link';
import { useTheme } from "@mui/material";
export default function NavIcons({ title, to, onClick, iconselect }) {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';
    return (
<Tooltip title={title}>
    <Link   component={RouterLink} to={to}>
        <IconButton onClick={onClick} sx={{ p: { xs: 0.5, sm: 1 } }}>
            <Avatar sx={{ width: { xs: 32, sm: 36 }, height: { xs: 32, sm: 36 }, fontSize: { xs: '0.9rem', sm: '1.1rem' }, color: isDark ? 'greydark.C900' : 'common.white', bgcolor: isDark ? 'grey.C100' : 'greydark.C900' }}> {iconselect} </Avatar>
        </IconButton>
    </Link>
</Tooltip>
);
}